require('./restApiExplorer.style.scss');

class RestApiExplorerController {
    constructor($scope, $filter, $window, storageService, config) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$window = $window;
        this.registryUrl = config.registryUrl;
        this.storageService = storageService;
        this.showModal = false;
        this.title = this.$filter('translate')('main.restApiExplorer.title');
    }

    $onInit() {
        this.actionButtons = [
            {
                title: this.$filter('translate')('main.restApiExplorer.registry'),
                action: () => {
                    this.openRegistryApiPage();
                },
                id: 'open-registry-endpoints-page'
            },
            {
                title: this.$filter('translate')('main.restApiExplorer.manager'),
                action: () => {
                    this.openManagerApiPage();
                },
                id: 'open-manager-endpoints-page'
            }
        ];
    }

    openManagerApiPage() {
        let managerUrl = this.storageService.getManagerHostname();
        this.$window.open(managerUrl + 'swagger/');  // manager
    }

    openRegistryApiPage() {
        this.$window.open(this.registryUrl + 'swagger/');  // registry or manager if standalone
    }
}

RestApiExplorerController.$inject = ['$scope', '$filter', '$window', 'storageService', 'config'];

const restApiExplorerComponent = {
    controller: RestApiExplorerController,
    template: require('./restApiExplorer.template.html'),
    bindings: {
        showModal: '='
    }
};

module.exports = restApiExplorerComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/restApiExplorer/restApiExplorer.component.js